// const API = "http://alrayhan-env.eba-s7jsbntt.us-east-2.elasticbeanstalk.com";

// const API = "https://api.alrayhanrestaurant.com";

const API = "https://alrayhan-api.applore.in";

export { API };
